import "../scss/page.scss";

import "../scss/marketing.scss";

import "./scripts/dm-marketing/navbar.js";
import "./scripts/calculatepadding.js";
import "./scripts/slick/market-flow.js";
import "./scripts/matchHeight/market-flow.js";
import "./scripts/dm-project-flow.js";
import "./scripts/video.js";
import "./scripts/marketing-flow/project-flow.js";